@if (sites?.length || userDetails?.allSites) {
  <mat-select
    class="filter-margin"
    matTooltip="Set a preferred site to pre-select Site Filters"
    matTooltipHideDelay="500"
    matTooltipShowDelay="500"
    [value]="selectedSites"
    (selectionChange)="onSiteSelected($event.value)"
    multiple
    disableRipple
    disableOptionCentering
    panelClass="globalFilterSelectPanel"
  >
    @if (userDetails?.allSites) {
      <mat-option
        class="disable-text-selection"
        [value]="0"
      >
        All sites
      </mat-option>
    }
    <mat-divider />
    @for (site of sites; track site.id) {
      <mat-option
        class="disable-text-selection"
        [value]="site.id"
      >
        {{ site.name }}
      </mat-option>
    }
  </mat-select>
}
